import React from 'react';

// Centralized observability surface for the editor.
// Console-only; swap the implementation when a real transport is wired in.

type Extras = { extra?: Record<string, unknown>; tags?: Record<string, string> };

export function captureException(error: unknown, context?: Extras): void {
  // eslint-disable-next-line no-console
  console.error('[logger] captureException', error, context);
}

export function captureMessage(message: string, context?: Extras): void {
  // eslint-disable-next-line no-console
  console.warn('[logger] captureMessage', message, context);
}

interface ErrorBoundaryState {
  hasError: boolean;
}

type ErrorBoundaryProps = React.PropsWithChildren<unknown>;

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo): void {
    captureException(error, { extra: { componentStack: info.componentStack } });
  }

  override render(): React.ReactNode {
    return this.state.hasError ? null : this.props.children;
  }
}
